<template>
	<div class="mx-3 mx-lg-0 position-relative">
		<div class="row overflow-hidden tabs-wrapper">
			<!-- desktop -->
			<div
				class="w-100 font-size-14 d-none d-lg-flex flex-row justify-content-between align-items-around"
			>	
				<template v-if="packagesToDisplay.length && packagesToDisplay">
					<div
						v-for="(packObj, packObj_i) in packagesToDisplay"
						:key="`${packObj_i}-${packObj.codePackage}`"
						:style="{ width: tabWidth }"
						:class="
							packCode === packObj?.codePackage
								? 'active font-weight-700'
								: 'text-grey-900'
						"
						class="package-tab"
						@click.stop="() => handlePackageChange(packObj)"
					>
						<div class="tab-inner-wrapper">
							<div class="d-flex justify-content-end align-items-center">
								<RadioCircle
									:active="packCode === packObj?.codePackage"
									:colorDefault="'#0042B8'"
									:colorActive="'white'"
									:additionalClasses="'me-1 me-xl-3'"
								/>
							</div>
							<span
								class="d-flex justify-content-center align-items-center pack-code"
							>
								{{ getPackNameForCode(packObj.codePackage) }}
							</span>
							<div class="d-flex justify-content-start align-items-center">
								<div
									v-if="
										packObj.codePackage !== 'HS' &&
										promos[packObj.codePackage] &&
										promos[packObj.codePackage] >= 5
									"
									class="d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-green ms-1 ms-xl-3"
								>
									<div
										class="prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap"
										v-bind:class="addDnoneClassIfABtest"
									>
										-{{ promos[packObj.codePackage] }}%
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>

		<!-- mobile -->
		<div
			class="mobile-packages-wrapper d-flex d-lg-none align-items-center justify-content-center mb-3 p-0 mt-3"
		>
			<div
				@click.stop="handleMobileDropdownOpen"
				class="mobile-packages form-control py-3 cursor-pointer position-relative px-3 d-flex justify-content-between"
				:style="
					packagesMobileDropdownOpen && {
						'box-shadow': `0px 0px 4px 0px ${colors.lightBlue}`,
						color: colors.lightBlue,
					}
				"
				style="height: initial"
			>
				<span class="font-weight-600 font-size-16">{{
					getPackNameForCode(packCode)
				}}</span>
				<span class="ml-2">
					<svg width="14" height="14" class="icon">
						<use
							data-v-7fb4dc0e=""
							xlink:href="#___icon___chevron-down-bold"
						></use>
					</svg>
				</span>
			</div>
		</div>
		<PackagesMobileDropdown
			@validateClick="(newPackCode) => handlePackageChange(newPackCode)"
		/>
	</div>
</template>

<script>
import PackagesMobileDropdown from "@/vue/planning/components/search/packagesMobileDropdown.vue"
import RadioCircle from "@/vue/common/radioCircle.vue"
import colors from "@/config/colors"
import { mapState, mapGetters } from "vuex"
import store from "@/vue/planning/store/store"
import { isABtest } from "@/utils/utils"
import getPackageComposition from "../../logic/getPackageComposition"
import { isCS } from "@/vue/planning/logic/cs"

export default {
	store,
	name: "Packages",

	components: {
		PackagesMobileDropdown,
		RadioCircle,
	},
	props: {
		packagesToDisplay: Array,
	},
	data() {
		return {
			colors,
		}
	},
	computed: {
		...mapState([
			"content",
			"packagesMobileDropdownOpen",
			"loading",
			"packCode",
			"packageId",
		]),
		...mapGetters([
			"maxPromosFromAvailablePackages",
			"availablePackCodes",
			"packNames",
		]),

		tabWidth() {
			return `${100 / this.packagesToDisplay.length}%`
		},

		promos() {
			const promoObject = {}
			this.availablePackCodes.forEach((packObj) => {
				promoObject[packObj.codePackage] =
					this.maxPromosFromAvailablePackages[packObj.codePackage]
			})
			return promoObject
		},
		addDnoneClassIfABtest() {
			const dNoneClass = isABtest() ? "d-none !important" : ""
			return dNoneClass
		},
	},
	methods: {
		async handlePackageChange(packObj) {
			if (this.packCode === packObj.codePackage) {
				this.$store.dispatch("setPackagesMobileDropdownOpen", false)
				return
			}

			this.$store.dispatch("setPackage", packObj.codePackage)
			this.$store.state.packageId = packObj.packageId
			if (packObj.codePackage !== "HS" && !isCS(packObj)) {
				await getPackageComposition(this.$store)
			}
		},
		handleMobileDropdownOpen() {
			this.$store.dispatch(
				"setPackagesMobileDropdownOpen",
				!this.packagesMobileDropdownOpen
			)
		},
		getPackNameForCode(packCode) {
			return this.packNames[packCode]
		},
	},
}
</script>

<style scoped>
.tab-inner-wrapper {
	display: grid;
	grid-template-columns: 70px 1fr 70px;
}

.package-tab {
	background: white;
	border-bottom: 1px solid #dee2e6;
	flex-grow: 1;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background 150ms ease-in-out, color 150ms ease-in-out,
		box-shadow 150ms ease-in-out;
}
.package-tab:hover:not(.active) {
	color: var(--primary-blue);
	box-shadow: inset 0px 0px 0px 1px var(--primary-blue) !important;
}
/* .tab.active:hover {
    background: #305c8b;
} */
.package-tab:not(:first-child) {
	border-right: 1px solid #dee2e6;
}
.package-tab:not(:last-child) {
	border-left: 1px solid #dee2e6;
}
.package-tab:last-child,
.package-tab:first-child {
	border-left: none;
	border-right: none;
}
.package-tab.active {
	background: #0042b8;
	border: none;
	color: white;
}

.package-tab:first-child {
	border-top-left-radius: 16px;
}

.package-tab:last-child {
	border-top-right-radius: 16px;
}

.tabs-wrapper {
	border-radius: 16px 16px 0 0;
	display: flex !important;
	flex-wrap: wrap !important;
	margin-right: -15px !important;
	margin-left: -15px !important;
	--bs-gutter-x: 0 !important;
}

.mobile-packages-wrapper,
.mobile-packages {
	border-radius: 8px;
}

.prestation-discount-container {
	border-radius: 37px;
}
</style>
